module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner01-006916bb0c19774d1738481a8b2dcfc3.png";